import angular from 'angular';

export const RECRUITER_WORKFLOW_STATUS = {
    PROSPECT: 'Prospect',
    CLAIMED: 'Claimed',
    ENGAGED: 'Engaged',
    READY: 'Ready',
    SAMPLES: 'Samples',
    SENT: 'Sent',
    FEEDBACK: 'Feedback',
    REJECTED: 'Rejected',
    HIRED: 'Hired',
    HIDDEN: 'Hidden',
    NONE: 'None',
};

angular.module('TALENYA-FE').constant('RECRUITER_WORKFLOW_STATUS', RECRUITER_WORKFLOW_STATUS);
